import React from 'react';
import Formulario from '../../Componentes/Formulario/Formulario';
import './Contato.css';



function Contato(){
  return( 
    <Formulario></Formulario>
    
)
 
  
};

export default Contato;

